Postlogin = (function (postlogin) {
    postlogin.AssessmentsList = {};
    const self = postlogin.AssessmentsList;
    const $assessmentsListTable = $('#assessments-list-table');

    const initBootstrapTable = function () {
        const columns = [
            {
                title: 'Image',
                field: 'assessment_image',
                align: 'center',
                valign: 'middle',
                sortable: false,
            },
            {
                title: 'Name',
                field: 'name',
                align: 'center',
                valign: 'middle',
                sortable: false,
            },
            {
                title: 'Assignments',
                field: 'times_assigned',
                align: 'left',
                valign: 'middle',
                sortable: false,
            },
            {
                title: 'Students',
                field: 'students_assigned_to',
                align: 'left',
                valign: 'middle',
                sortable: false,
            },
            {
                title: '',
                field: 'actions',
                align: 'center',
                valign: 'middle',
                sortable: false,
            },
        ];

        $assessmentsListTable.bootstrapTable({
            formatNoMatches() {
                return 'No assessments to show';
            },
            classes: 'table table-hover table-condensed',
            striped: true,
            showRefresh: false,
            showToggle: false,
            showColumns: false,
            showPaginationSwitch: false,
            idField: 'assessment_id',
            minimumCountColumns: '2',
            pagination: true,
            search: true,
            sortName: 'name',
            sortOrder: 'asc',
            toolbar: '#report-toolbar',
            toolbarAlign: 'right',
            searchAlign: 'left',
            clickToSelect: false,
            maintainSelected: false,
            sidePagination: 'server',
            url: '/assessments/json',
            pageSize: 25,
            queryParamsType: 'other',
            queryParams(params) {
                const myParams = {};
                myParams.search_term = params.searchText;
                myParams.page = params.pageNumber;
                myParams.page_size = params.pageSize;
                myParams.order_by = params.sortName;
                myParams.sort_order = params.sortOrder;
                myParams.published = 1;

                return myParams;
            },
            columns,
            responseHandler(res) {
                // TODO: Move all this into the columns themselves.
                const formattedResult = {};
                formattedResult.total = res.meta.total;
                formattedResult.rows = res.data;

                $(formattedResult.rows).each((i, result) => {
                    let row = result;
                    // we're getting a UTC date from the DB... need to convert it to the users timezone...?
                    row = Jr.Utils.convertRowDate(row, 'l', []);

                    const assignmentsListUrl = $assessmentsListTable
                        .attr('data-assignments-list-url')
                        .replace(':assessment_id', row.assessment_id);

                    if (row.total_time > 0) {
                        const duration = moment.duration(row.total_time * 1000); // convert seconds to milliseconds
                        row.total_time = `<span title="${duration.asMinutes()} minutes">${duration.humanize()}</span>`;
                    }

                    const timesAssigned = row.times_assigned;
                    row.times_assigned += ' assignment';
                    if (+timesAssigned !== 1) {
                        row.times_assigned += 's';
                    }

                    row.times_assigned = `<a href="${assignmentsListUrl}" class="btn btn-hollow-dark-gray">${row.times_assigned}</a>`;

                    const studentsAssignedTo = row.students_assigned_to;
                    row.students_assigned_to += ' student';
                    if (+studentsAssignedTo !== 1) {
                        row.students_assigned_to += 's';
                    }
                    const assessmentsViewUrl = $assessmentsListTable
                        .attr('data-assessment-view-url')
                        .replace(':assessment_id', row.assessment_id);
                    row.students_assigned_to = `<a href="${assessmentsViewUrl}" class="btn btn-hollow-dark-gray">${row.students_assigned_to}</a>`;

                    if (row.assessment_image) {
                        row.assessment_image = `<a href="${assignmentsListUrl}"><img src="${row.assessment_image}" style="width: 140px;"/></a>`;
                    }

                    row.name = `<a href="${assignmentsListUrl}">${row.name}</a>`;

                    row.type = `<strong>${row.type}</strong><br>${row.description}`;

                    const assessmentPreviewUrl = row.type_slug === 'ccis'
                        ? $assessmentsListTable.attr('data-assessment-ccis-preview-url').replace(':assessment_guid', row.guid)
                        : '';

                    row.actions = `<a href="${assessmentPreviewUrl}" class="btn btn-hollow-green" target="_blank">Preview</a>`;

                    const assignmentsAddUrl = $assessmentsListTable
                        .attr('data-assignments-add-url')
                        .replace(':assessment_id', row.assessment_id);
                    row.actions += `<a href="${assignmentsAddUrl}" class="btn btn-hollow-blue">Assign</a>`;
                });

                return formattedResult;
            },
            onLoadSuccess() {
                $('time.timeago').timeago();
            },
            rowStyle() {
                const classes = '';

                return {
                    classes,
                };
            },
        });
    };

    self.init = function () {
        initBootstrapTable();
    };

    return postlogin;
}(Postlogin || {}));
